var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"required_badge"},[_vm._v("必須")])}
var staticRenderFns = []

export { render, staticRenderFns }